
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.5 32.5v-1.458c0-3.056 2.468-5.542 5.5-5.542s5.5 2.486 5.5 5.542V32.5h-11z","fill":"#98CCFD"}}),_c('path',{attrs:{"d":"M34 26c2.757 0 5 2.262 5 5.042V32H29v-.958C29 28.262 31.243 26 34 26m0-1c-3.314 0-6 2.705-6 6.042V33h12v-1.958C40 27.705 37.314 25 34 25z","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"34","cy":"19","r":"3.5","fill":"#fff"}}),_c('path',{attrs:{"d":"M34 16c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0-1a4 4 0 1 0 0 8 4 4 0 0 0 0-8z","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"9","cy":"13","r":"5.5","fill":"#fff"}}),_c('path',{attrs:{"d":"M9 8c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-1c-3.315 0-6 2.685-6 6s2.685 6 6 6A6 6 0 0 0 9 7z","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"23","cy":"16","r":"4.5","fill":"#fff"}}),_c('path',{attrs:{"d":"M23 12c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m0-1c-2.763 0-5 2.238-5 5s2.237 5 5 5a5 5 0 1 0 0-10z","fill":"#4788C7"}}),_c('path',{attrs:{"d":"M15.5 32.5V31c0-4.136 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5v1.5h-15z","fill":"#B6DCFE"}}),_c('path',{attrs:{"d":"M23 24c3.86 0 7 3.14 7 7v1H16v-1c0-3.86 3.14-7 7-7m0-1a8 8 0 0 0-8 8v2h16v-2a8 8 0 0 0-8-8z","fill":"#4788C7"}}),_c('path',{attrs:{"d":"M.5 32.5V30c0-4.687 3.813-8.5 8.5-8.5s8.5 3.813 8.5 8.5v2.5H.5z","fill":"#DFF0FE"}}),_c('path',{attrs:{"d":"M9 22c4.411 0 8 3.589 8 8v2H1v-2c0-4.411 3.589-8 8-8m0-1a9 9 0 0 0-9 9v3h18v-3a9 9 0 0 0-9-9z","fill":"#4788C7"}})])
          )
        }
      }
    